import type { InterventionSectionSaveBarProps } from "./intervention-section-save-bar.type";

import AppSaveBar from "@/modules/app-save-bar";

import { useInterventionSectionSaveBar } from "./intervention-section-save-bar.hook";

import "./intervention-section-save-bar.style.less";

const InterventionSectionSaveBar = ({
  intervention,
  loading,
}: InterventionSectionSaveBarProps) => {
  const { onSaveClick, onCancelClick } = useInterventionSectionSaveBar();

  return (
    <AppSaveBar
      date={intervention?.updated_at}
      onSave={onSaveClick}
      onCancel={onCancelClick}
      loading={loading}
    />
  );
};

export default InterventionSectionSaveBar;
